import React from 'react';
import { Settings } from 'lucide-react';

export interface ModeStyle01Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  modeLabels?: Record<string, string>;
}

// Default mode translations
const DEFAULT_MODE_LABELS: Record<string, string> = {
  '1': '節能',
  '3': '標準',
  '5': '強力',
  '8': '連續',
  'auto': '自動',
  'cool': '製冷',
  'heat': '制暖',
  'dry': '除濕',
  'fan': '送風'
};

/**
 * Mode Style 01 - Pill Buttons
 * Command: SetModes
 * Pill-shaped toggle buttons for mode selection
 */
export const Style01_Pills: React.FC<ModeStyle01Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '運轉模式',
  modeLabels
}) => {
  const getModeLabel = (mode: string): string => {
    return modeLabels?.[mode] || DEFAULT_MODE_LABELS[mode] || mode;
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Settings className="w-4 h-4 text-indigo-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((mode) => {
          const isSelected = value === mode;
          return (
            <button
              key={mode}
              onClick={() => onChange(mode)}
              disabled={disabled || loading}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                isSelected
                  ? 'bg-indigo-500 text-white shadow-lg shadow-indigo-500/30'
                  : 'bg-slate-700/50 text-slate-300 hover:bg-slate-600'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : getModeLabel(mode)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style01_Pills;
